<template>
  <div id="description">
    <HeaderSidebarRight :id_header="id_header" :title_header="title_header" />
    
    <div v-if="_g_UserFeatures.permissions.description_value">
      <div class="info-ticker-box">
        <p class="text-info-ticker">Ticker: <span class="text-bold">{{getFormattedSelectedTickerProperty(["ticker"])}}</span></p>
      </div>
      <div class="ticker-description-container">
        <div v-if="_g_SelectedTicker.description == null || _g_SelectedTicker.description == ''">
          <p id="ticker-description" class="ticker-description-null typo-body-2"> Este ticker no dispone de descripción </p>
        </div>
        <div v-else>
          <p class="description-description typo-body-2"><strong>{{_g_SelectedTicker.sector}} | {{_g_SelectedTicker.industria}}</strong></p>
          <p id="ticker-description" class="ticker-description description-description typo-body-2">{{_g_SelectedTicker.description}}</p>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="not-allowed-description"> Su plan actual no tiene acceso a esta herramienta </p>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import HeaderSidebarRight from './HeaderSidebarRight.vue';

export default {
  name: 'Description',
  components:{
    HeaderSidebarRight,
  },
  data: () => ({
    id_header: 'description',
    title_header: 'Descripción',
  }),
  mounted() {
  },
  created: function() {
  },
  computed: {
      ...mapGetters(['_g_SelectedTicker', "_g_UserFeatures"]),
  },
  methods: {
    getFormattedSelectedTickerProperty(prop_array) {
      const selected_ticker = this._g_SelectedTicker;

      let goal = "";
      prop_array.forEach(prop => {
        goal = selected_ticker[prop];
        if(goal == undefined) {
          return "";
        }
      });

      try {
        const formattedGoal = goal.toFixed(2);
        return formattedGoal;
      }
      catch(e) {
        return goal;
      }
    },
  },
}
</script>


<style lang="scss" scoped>
  @import "@/styles/basics/globals.scss";

  .ticker-description{
    padding: 10px;
    margin-bottom: 40px;
  }

  .description-description {
    padding: 0 32px;
    margin-top: 0px;
  }

  .ticker-name{
    text-align: center;
    font-weight: bold;
    font-size: 24px;
  }

  .info-ticker-box {
     width: 100%;
     display: flex;
     justify-content: center;
  }

  .text-info-ticker {
    text-align: center;
    background-color: #F3F4F7;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin-bottom: 24px;
    width: 130px;
    padding: 7px 20px;
    color: black;
  }

  .text-bold {
    font-weight: bold;
  }

  #description p {
    color: var(--custom-color-right-menu-font);
  }

  #description .text-info-ticker {
    background-color: var(--custom-color-right-menu-highlight);
  }
  .ticker-description-null{
    margin-top: 20px;
    text-align: center;
  }

  .not-allowed-description{
    margin-top: 20px;
    text-align: center;
  }
</style>